import { apiErrorHandler } from '../errorHandler'

export async function addUserToProject(projectId: number, userId: number): Promise<void> {
  const res = await fetch(`/api/projects/${projectId}/user/${userId}`, {
    method: 'PUT',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId, userId })
  })
  await apiErrorHandler(res)
}

export async function removeUserFromProject(projectId: number, userId: number): Promise<void> {
  const res = await fetch(`/api/projects/${projectId}/user/${userId}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId, userId })
  })
  await apiErrorHandler(res)
}
